import { H3 } from '@/components/Headings';
import { TextSmall } from '@/components/Texts';
import { colors } from '@/styles/theme/colors';
import { Stack } from '@chakra-ui/react';

const CookiesPolicy = () => {
  return (
    <Stack w='full' maxW={'8xl'}>
      <Stack
        w='full'
        textAlign={'start'}
        spacing={2}
        py={{ base: 4, md: 12 }}
        maxW={'100%'}
      >
        <Stack w='full'>
          <H3>Cookies Policy</H3>
        </Stack>
        <TextSmall>
          Welcome to Diment.io (“the Site”). This cookies policy should be read
          in conjunction with our Privacy Policy.
        </TextSmall>
        <TextSmall pl={5} fontWeight={500}>
          <TextSmall
            fontWeight={500}
            as={'span'}
            color={colors.diment.lightBlue}
          >
            1.
          </TextSmall>{' '}
          The Site may use “cookies”. A cookie is a small text file containing a
          unique identification number that identifies a customer’s browser each
          time that customer visits a website. The use of cookies is industry
          standard practice and many major browsers are initially set up to
          accept them. You can reset your browser to either refuse to accept all
          cookies or to notify you when you have received a cookie. However, if
          you refuse to accept cookies, you may not be able to use some of the
          features available on the Site.
        </TextSmall>
        <TextSmall pl={5} fontWeight={500}>
          <TextSmall
            fontWeight={500}
            as={'span'}
            color={colors.diment.lightBlue}
          >
            2.
          </TextSmall>{' '}
          If you choose to disable or block our cookies on your computer or
          other device you will need to do this through your browser. Click on
          the ‘Help’ menu on your particular browser to learn how to manage your
          cookie preferences. Alternatively, you can visit www.aboutcookies.org
          or www.youronlinechoices.eu for comprehensive information on how to
          manage cookies.
        </TextSmall>
        <TextSmall pl={5} fontWeight={500}>
          <TextSmall
            fontWeight={500}
            as={'span'}
            color={colors.diment.lightBlue}
          >
            3.
          </TextSmall>{' '}
          We set cookies (first party cookies) on web pages, however, where we
          require additional information, we may also allow other companies to
          host cookies on our Site (third party cookies). These companies have
          been carefully selected by us and are required to meet contractual
          obligations they have with us.
        </TextSmall>
        <TextSmall>What do we use cookies for?</TextSmall>
        <TextSmall pl={5} fontWeight={500}>
          <TextSmall
            fontWeight={500}
            as={'span'}
            color={colors.diment.lightBlue}
          >
            4.
          </TextSmall>{' '}
          The cookies on the Site may be from any of the following categories:
        </TextSmall>
        <TextSmall pl={10} fontWeight={500}>
          <TextSmall
            fontWeight={500}
            as={'span'}
            color={colors.diment.lightBlue}
          >
            i.
          </TextSmall>{' '}
          Strictly Necessary cookies - these are used for technical reasons and
          are necessary to enable the Site to operate efficiently so that you
          can navigate the Site with ease and use specific features. These
          include, for example, cookies that help us to debug any errors. If
          these cookies are blocked or disabled, some of the Site may not
          operate effectively.
        </TextSmall>
        <TextSmall pl={10} fontWeight={500}>
          <TextSmall
            fontWeight={500}
            as={'span'}
            color={colors.diment.lightBlue}
          >
            ii.
          </TextSmall>{' '}
          Functionality cookies - these are used to improve the functionality of
          the Site and make it easier to use. They help us to identify you as a
          repeat user of the Site and help us remember your preferences (for
          example, your choice of language or region).
        </TextSmall>
        <TextSmall pl={10} fontWeight={500}>
          <TextSmall
            fontWeight={500}
            as={'span'}
            color={colors.diment.lightBlue}
          >
            iii.
          </TextSmall>{' '}
          Analytical - these record your visit to our Site, the pages you have
          visited and the links you have followed. We will use this information
          to make the Site and the advertising displayed on it (if any) more
          relevant to your interests. We may also share this information with
          third parties for this purpose. How do we share cookies?
        </TextSmall>
        <TextSmall pl={5} fontWeight={500}>
          <TextSmall
            fontWeight={500}
            as={'span'}
            color={colors.diment.lightBlue}
          >
            5.
          </TextSmall>{' '}
          We may share information that we collect through cookies, in
          aggregated form, with carefully selected third parties for the
          purposes set out above, unless you disable or block cookies.
        </TextSmall>
        <TextSmall fontWeight={700}>Necessary (1) always active: </TextSmall>
        <TextSmall>
          Necessary cookies are required to enable the basic features of this
          site, such as providing secure log-in or adjusting users consent
          preferences. These cookies do not store any personally identifiable
          data.
        </TextSmall>
        <TextSmall>
          <TextSmall as='span' fontWeight={700}>
            Cookie:
          </TextSmall>{' '}
          __cfruid <br />
          <TextSmall as='span' fontWeight={700}>
            Duration:
          </TextSmall>{' '}
          session <br />{' '}
          <TextSmall as='span' fontWeight={700}>
            Description:
          </TextSmall>{' '}
          Cloudflare sets this cookie to identify trusted web traffic.
        </TextSmall>
        <TextSmall fontWeight={700}>Functional (0):</TextSmall>
        <TextSmall>
          Functional cookies help perform certain functionalities like sharing
          the content of the website on social media platforms, collecting
          feedback, and other third-party features.
        </TextSmall>
        <TextSmall fontWeight={700}>Marketing/ Advertisement (0):</TextSmall>
        <TextSmall>
          Advertisement cookies are used to provide visitors with visited
          previously and to analyze the effectiveness of the ad campaigns.
        </TextSmall>
        <TextSmall fontWeight={700}>Analytics (1) user can close:</TextSmall>
        <TextSmall>
          We create pseudonymous user profiles with the help of Google Analytics
          in order to design our websites according to your needs. Google
          Analytics uses targeting cookies that are stored on your terminal
          device and can be read by us. In this way, we are able to recognise
          and count returning visitors as such and to find out how often our web
          pages have been accessed by different users. The data processing is
          based on Art. 6 para. 1 lit. a GDPR (consent).
        </TextSmall>

        <TextSmall>
          The information generated by the cookie about your use of our website
          is usually transferred to a Google server in the USA and stored there.
          However, as we have activated IP anonymisation on our website, your IP
          address will be shortened by Google beforehand within member states of
          the European Union. Only in exceptional cases will the full IP address
          be transmitted to a Google server in the USA and only shortened there
          (for more information on the purpose and scope of data collection, see
          e.g. https://policies.google.com/privacy?hl=de&gl=de). We have also
          concluded an order processing agreement with Google LLC (USA) in
          accordance with Art. 28 GDPR. Accordingly, Google will use all
          information strictly for the purpose of evaluating the use of our
          websites for us and compiling reports on website activity.
        </TextSmall>
        <TextSmall>
          Google sets the following cookies when you visit our website and
          consent to the use of the Google Analytics cookie:
        </TextSmall>
        <TextSmall>
          <TextSmall as='span' fontWeight={700}>
            Cookie:
          </TextSmall>{' '}
          _ga_*
          <br />
          <TextSmall as='span' fontWeight={700}>
            Duration:
          </TextSmall>{' '}
          1 year 1 month 4 days
          <br />{' '}
          <TextSmall as='span' fontWeight={700}>
            Description:
          </TextSmall>{' '}
          {`Google Analytics sets this cookie to store and count page views. Google
        Analytics sets this cookie to calculate visitor, session and campaign
        data and track site usage for the site's analytics report. The cookie
        stores information anonymously and assigns a randomly generated number
        to recognise unique visitors.`}
        </TextSmall>
        <TextSmall>
          You can revoke your consent at any time. Please use one of the
          following options to do so:
        </TextSmall>
        <TextSmall pl={5}>
          - You inform us that you wish to revoke your consent.
        </TextSmall>
        <TextSmall pl={5}>
          - You may refuse the use of cookies by selecting the appropriate
          settings on your browser, however please note that if you do this you
          may not be able to use the full functionality of this website.
        </TextSmall>
        <TextSmall pl={5}>
          - You can also prevent the collection of data generated by the cookie
          and related to your use of our website (including your IP address) by
          Google, as well as the processing of this data by Google, by
          downloading and installing the browser plugin available at the
          following link (https://tools.google.com/dlpage/gaoptout?hl=de).
        </TextSmall>

        <TextSmall fontWeight={700}>Performance (0) user can close:</TextSmall>
        <TextSmall>
          Performance cookies are used to understand and analyze the key
          performance indexes of the website which helps in delivering a better
          user experience for the visitors.
        </TextSmall>
        <TextSmall fontWeight={700}>Preferences (0):</TextSmall>
        <TextSmall fontWeight={700}>Unclassified (0):</TextSmall>
        <Stack mt={4} w='full'>
          <TextSmall textAlign={'end'} fontWeight={700}>
            7.12.2023
          </TextSmall>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default CookiesPolicy;
